var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNutritsiologiyaIAdapPitanie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 46.087,
    height: 48.155,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5.67 5.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil0{fill:#61ccf8;fill-rule:nonzero}.fil1,.fil10,.fil8{fill:#68c37d;fill-rule:nonzero}.fil10,.fil8{fill:#97d57e}.fil10{fill:#add841}.fil13,.fil14,.fil9{fill:#cbed74;fill-rule:nonzero}.fil13,.fil14{fill:#d9ef78}.fil13{fill:#e7387f}.fil16,.fil17,.fil7{fill:#fdca00;fill-rule:nonzero}.fil16,.fil7{fill:#ffe400}.fil7{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2792289461088"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59 3.76A2.838 2.838 0 0 0 2.83.25 2.838 2.838 0 0 0 .02 3.51l5.56.25z",
    className: "fil0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71 5.69c-.01-.02-.01-.05-.01-.07-.04-.5-.14-1.63-.17-1.92l-.07-.81h-.04c-.09 0-.17-.08-.17-.17 0-.09.07-.17.16-.17a.495.495 0 0 1-.04-.13c-.06-.28-.24-.4-.41-.44a.678.678 0 0 0-.71.27c-.11.15-.17.35-.02.6.2.35-.08.45-.2.65.14.99.79 1.81 1.68 2.2z",
    className: "fil1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71 5.69c-.01-.02-.01-.05-.01-.07-.04-.5-.14-1.63-.17-1.92l-.07-.81h-.04c-.09 0-.17-.08-.17-.17 0-.09.07-.17.16-.17a.495.495 0 0 1-.04-.13c-.06-.28-.24-.4-.41-.44a.678.678 0 0 0-.71.27c-.11.15-.17.35-.02.6.2.35-.08.45-.2.65.14.99.79 1.81 1.68 2.2z",
    className: "fil1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.71 5.69c-.01-.02-.01-.05-.01-.07-.04-.5-.14-1.63-.17-1.92l-.07-.81h-.04c-.09 0-.17-.08-.17-.17 0-.09.07-.17.16-.17a.495.495 0 0 1-.04-.13c-.06-.28-.24-.4-.41-.44a.678.678 0 0 0-.71.27c-.1.14-.16.33-.04.57.07-.04.16-.06.25-.04.11.02.2.11.24.21.04.1.02.21-.01.32-.03.1-.08.2-.11.3-.06.19-.05.41.05.58.1.16.27.26.4.4.19.22.26.54.18.82.16.11.32.2.5.28z",
    style: {
      fill: "#489160",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72 2.73c0 .08-.07.15-.15.15h-.05l-.15 1.73c.08-.01.17 0 .25.03.08.03.16.03.24 0 .12-.04.26-.04.38-.01.04.01.06.04.07.07v.01c.13.06.23.16.29.27l.65-.43c.15-.25.26-.52.33-.81V.96c0-.23-.19-.42-.42-.42h-.71v.05c0 .15-.12.27-.27.27h-1.2c-.15 0-.27-.12-.27-.27V.54H2c-.23 0-.42.19-.42.42v1.61h1.97c.08 0 .15.07.15.15z",
    style: {
      fill: "#384051",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5.55h-.49c-.23 0-.42.19-.42.42v1.61h.93V.89C2.3.72 2.5.56 2.5.56z",
    style: {
      fill: "#2d3243",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26.97a.09.09 0 0 0-.09-.09H2.02a.09.09 0 0 0-.09.09v1.6h1.64c.08 0 .15.07.15.15 0 .08-.07.15-.15.15h-.05L3.37 4.6c.08-.01.17 0 .25.03.08.03.16.03.24 0 .12-.04.26-.04.38-.01.04.01.06.04.07.07v.01c.21.1.35.3.37.52.23-.2.42-.43.58-.68V.95z",
    style: {
      fill: "#f7f3f1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.52.88h-.5a.09.09 0 0 0-.09.09v1.6h.5V.97c0-.05.04-.09.09-.09z",
    style: {
      fill: "#cde2ff",
      fillRule: "nonzero"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85 1.72h-.28c-.08 0-.15.07-.15.15v.28c0 .08.07.15.15.15h.28c.08 0 .15-.07.15-.15v-.28c0-.08-.07-.15-.15-.15zM4.71 1.96H3.49a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h1.22c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM4.34 2.31h-.85a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.85c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM4.71 2.88h-.67a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.67c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM4.34 3.22h-.5a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.5c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM4.71 3.8h-.92a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.92c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM4.34 4.14h-.57a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.57c.05 0 .09.04.09.09 0 .05-.04.09-.09.09z",
    className: "fil7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m2.65 2.16-.17-.17c-.04-.04-.04-.09 0-.13.04-.04.09-.04.13 0l.1.1.26-.26c.04-.04.09-.04.13 0 .04.04.04.09 0 .13l-.33.33c-.04.04-.09.04-.13 0z",
    className: "fil0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m1.59 4.4-.01-.13L1 2.9c-.05-.11-.22-.05-.18.07l.87 2.6-.1-1.17z",
    className: "fil8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m1.22 4.07-.5-.27c-.11-.06-.2.1-.09.16l.71.45-.12-.35z",
    className: "fil8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17 5.86a.51.51 0 0 1-.21-.15.638.638 0 0 1-.17-.47c.02-.22.15-.42.35-.52v-.01c.01-.04.04-.06.07-.07.05-.02.11-.03.16-.03l.15-1.73H.99h.41l.24 2.74c0 .02 0 .03.01.05.36.16.75.25 1.17.25.07 0 .13 0 .2-.01a.31.31 0 0 0 .13-.06z",
    className: "fil9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m2.36 5.84-.22-2.57c-.01-.16.07-.31.2-.38H1.42l.24 2.74c0 .02 0 .03.01.05.22.1.46.17.7.21 0-.02-.01-.03-.01-.05z",
    className: "fil10"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86 3.67c-.19 0-.19.13-.38.13s-.19-.13-.38-.13-.19.13-.38.13c-.12 0-.16-.05-.23-.09l.17 1.92c0 .02 0 .03.01.05 0 0 .01 0 .01.01.35.16.75.25 1.16.25.15 0 .29-.01.44-.03l-.03-.03c-.12-.13-.46-.44-.45-.62.02-.22.15-.42.35-.52v-.01c.01-.04.04-.06.07-.07.05-.02.11-.03.16-.03l.08-.91c-.07.04-.11.09-.23.09-.19 0-.19-.13-.38-.13z",
    className: "fil10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.37 5.89c0-.02-.01-.03-.01-.05l-.19-2.16c-.02 0-.05-.01-.07-.01-.19 0-.19.13-.38.13-.12 0-.16-.05-.23-.09l.17 1.92c0 .02 0 .03.01.05.22.1.46.17.7.21z",
    style: {
      fill: "#5db33a",
      fillRule: "nonzero"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73 4.77a.09.09 0 0 1-.09-.09c0-.1.03-.35.27-.46.05-.02.1 0 .12.05.02.05 0 .1-.05.12-.07.03-.16.11-.16.29 0 .05-.04.09-.09.09z",
    className: "fil1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.31 4.7c.01.03.01.05 0 .08-.03.08-.09.12-.13.12-.03 0-.06-.01-.09-.01-.04-.01-.07-.02-.11-.01-.04.01-.07.03-.1.06-.01.01-.02.02-.04.03-.07.05-.18.05-.25 0a.265.265 0 0 1-.06-.05.444.444 0 0 0-.11-.08c-.01 0-.03-.01-.05-.01-.02 0-.05 0-.07.01-.07.01-.13.02-.16-.05-.01-.03-.01-.06 0-.08-.21.09-.36.3-.37.53-.02.31.17.58.45.66a2.85 2.85 0 0 0 1.46-.67.642.642 0 0 0-.39-.53z",
    style: {
      fill: "#e5646e",
      fillRule: "nonzero"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64 5.34A.64.64 0 0 1 3.77 5c-.06.01-.13 0-.18-.03a.265.265 0 0 1-.06-.05.444.444 0 0 0-.11-.08c-.01 0-.03-.01-.05-.01-.02 0-.05 0-.07.01-.07.01-.13.02-.16-.05-.01-.03-.01-.06 0-.08-.21.09-.36.3-.37.53-.02.31.17.58.45.66.18-.03.36-.07.54-.13a.647.647 0 0 1-.13-.43z",
    className: "fil13"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57 2.9H1.39c-.09 0-.17-.08-.17-.17 0-.09.08-.17.17-.17h2.18c.09 0 .17.08.17.17 0 .09-.08.17-.17.17z",
    className: "fil14"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23 2.73c0-.09.08-.17.17-.17H1.39c-.09 0-.17.08-.17.17 0 .09.08.17.17.17H2.4c-.09 0-.17-.08-.17-.17z",
    className: "fil9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49 3.47H3.2a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.29c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM3.46 3.81h-.18a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.18c.05 0 .09.04.09.09 0 .05-.04.09-.09.09z",
    className: "fil14"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43 4.16h-.29a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.29c.05 0 .09.04.09.09 0 .05-.04.09-.09.09zM3.4 4.5h-.18a.09.09 0 0 1-.09-.09c0-.05.04-.09.09-.09h.18c.05 0 .09.04.09.09 0 .05-.04.09-.09.09z",
    className: "fil9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24 4.63a.552.552 0 0 0-.38.01c-.08.03-.16.03-.23 0a.682.682 0 0 0-.4 0c-.07.02-.1.1-.07.16.05.11.18.03.28.06.07.02.11.08.16.12.08.05.19.05.26 0 .04-.03.08-.08.13-.09.06-.01.13.03.2.03.05 0 .11-.05.14-.13.02-.07-.01-.14-.08-.16z",
    className: "fil8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.67 0h-.14c-.18 0-.33.15-.33.33h.81c0-.18-.15-.33-.33-.33z",
    style: {
      fill: "#fff442",
      fillRule: "nonzero"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.52.18c0-.08.05-.15.12-.18h-.11c-.18 0-.33.15-.33.33h.41C3.56.3 3.53.24 3.53.17z",
    className: "fil16"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2.32H3A.29.29 0 0 0 3 .9h1.2a.29.29 0 0 0 0-.58z",
    className: "fil17"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.4.61c0-.13.09-.25.21-.29H3A.29.29 0 0 0 3 .9h.61A.303.303 0 0 1 3.4.61z",
    style: {
      fill: "#feac00",
      fillRule: "nonzero"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99 1.39H3.9c-.07 0-.13-.03-.17-.09a.076.076 0 0 0-.05-.02h-.17c-.02 0-.03.01-.05.02-.04.06-.1.09-.17.09H3.2c-.13 0-.24-.11-.24-.24V.87c0-.05.04-.09.09-.09.05 0 .09.04.09.09v.28c0 .03.03.06.06.06h.09c.01 0 .02 0 .02-.01.05-.06.12-.1.2-.1h.17c.08 0 .15.04.2.1 0 .01.01.01.02.01h.09c.03 0 .06-.03.06-.06V.87c0-.05.04-.09.09-.09.05 0 .09.04.09.09v.28c0 .13-.11.24-.24.24z",
    className: "fil16"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 1.09h-.09c-.08 0-.15.04-.2.1 0 .01-.01.01-.02.01H3.2c-.03 0-.06-.03-.06-.06V.86a.09.09 0 0 0-.09-.09.09.09 0 0 0-.09.09v.28c0 .13.11.24.24.24h.09c.07 0 .13-.03.17-.09.01-.02.03-.02.05-.02h.09c-.1-.1 0-.19 0-.19z",
    className: "fil17"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72 4.65c-.03 0-.07-.01-.1-.02a.682.682 0 0 0-.4 0c-.07.02-.1.1-.07.16.05.11.18.03.28.06.07.02.11.08.16.12.08.05.19.05.26 0-.29-.1-.13-.32-.13-.32z",
    className: "fil1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.58,
    className: "fil13",
    transform: "matrix(.02163 -.09151 .09151 .02163 3.66 5.51)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.69,
    cy: 5.28,
    r: 0.09,
    className: "fil13"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.01,
    cy: 5.25,
    r: 0.08,
    className: "fil13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritsiologiyaIAdapPitanie);
export default __webpack_public_path__ + "static/media/nutritsiologiya-i-adap_pitanie.3543aad379ddf35b4e361d32ec57d275.svg";
export { ForwardRef as ReactComponent };